import { useEffect, useState } from "react";
import { Alert, Button, Spinner, Table } from "react-bootstrap";
import { fetchLegalHistory, openAcceptedPdf } from "@/api/legal.js";
import { formatDate } from "@/utils/formatDate.js";

/**
 * Pestaña "Documentos legales" del perfil: cada documento aceptado, en qué
 * versión y cuándo, con la descarga del PDF exacto que se aceptó (el contrato,
 * con su nombre y la fecha). Una versión nueva es una fila nueva; las
 * anteriores se quedan.
 */
const LegalDocumentsTab = () => {
  const [rows, setRows] = useState(null);
  const [error, setError] = useState(false);
  const [opening, setOpening] = useState(null);

  useEffect(() => {
    fetchLegalHistory()
      .then(setRows)
      .catch(() => setError(true));
  }, []);

  const download = async (id) => {
    setOpening(id);
    try {
      await openAcceptedPdf(id);
    } finally {
      setOpening(null);
    }
  };

  if (error) {
    return (
      <Alert variant="danger">
        No se pudieron cargar tus documentos legales.
      </Alert>
    );
  }
  if (rows === null) {
    return <Spinner animation="border" size="sm" />;
  }
  if (rows.length === 0) {
    return <p className="text-muted">Todavía no has aceptado documentos.</p>;
  }

  return (
    <Table responsive hover className="align-middle">
      <thead>
        <tr>
          <th>Documento</th>
          <th>Versión</th>
          <th>Fecha de aceptación</th>
          <th className="text-end">Descarga</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => (
          <tr key={row.id}>
            <td>{row.title}</td>
            <td>{row.version}</td>
            <td>{row.accepted ? formatDate(row.acceptedAt) : "No aceptado"}</td>
            <td className="text-end">
              <Button
                size="sm"
                variant="outline-primary"
                onClick={() => download(row.id)}
                disabled={opening === row.id}
              >
                <i className="bi bi-file-earmark-pdf me-1" />
                PDF
              </Button>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default LegalDocumentsTab;
